import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useUser } from "../context/UserContext";
import LayoutChat from '../layout/LayoutChat';
import ChatBox from '../components/ChatBox';

const Chat = () => {
    const { user, authService } = useUser();
    const [sessions, setSessions] = useState();
    const [refreshAll, setRefreshAll] = useState(false);
    const maxChat = 3;
    const chatArray = [...Array(maxChat).keys()].reverse();

    useEffect(() => {
        getSessions();
    }, []);

    useEffect(() => {
        if (refreshAll) {
            getSessions();
            
            setTimeout(() => {
                setRefreshAll(false);
            }, 3000);
        }
    }, [refreshAll]);

    const getSessions = async () => {
        try {
            // const response = await axios.get(`${config.apiBaseUrl}/chat/sessions`, {
            const response = await authService.get(`/chat/sessions`, {
                params: {
                    user_id: user.user_id,
                }
            });
            // console.log(response?.data);
            setSessions(response?.data);

        } catch {
            toast.error("Failed to get sessions");
        }
    };
    
    const handleDelete = (chatIndex) => {
        setRefreshAll(true);
    };

    return (
        <LayoutChat>
                    {/* <ChatBox
                        chatKey={`main-0`}
                        sessions={sessions}
                        chatIndex={0}
                        refreshAll={refreshAll}
                        setRefreshAll={setRefreshAll}
                        onDeleteSession={handleDelete}
                    /> */}

            {chatArray.map((e, chatIndex) => {
                if (chatArray[chatIndex] > 0) {
                    return (
                        <div key={`web-${chatIndex}`} className='hidden custom-flex mt-2'>
                            <ChatBox
                                chatKey={`web-${chatIndex}`}
                                chatIndex={chatArray[chatIndex]}
                                sessions={sessions}
                                refreshAll={refreshAll}
                                setRefreshAll={setRefreshAll}
                                onDeleteSession={handleDelete}
                            />
                        </div>
                    ) 
                }
            })}

            <div className='mt-2'>
                <div key={`main-0`}>
                    <ChatBox
                        chatKey={`main-0`}
                        sessions={sessions}
                        chatIndex={0}
                        refreshAll={refreshAll}
                        setRefreshAll={setRefreshAll}
                        onDeleteSession={handleDelete}
                    />
                </div>

                {/* {chatArray.reverse().map((e, chatIndex) => {
                    if (chatArray[chatIndex] > 0) {
                        return (
                        <div key={`mobile-${chatIndex}`} className='flex custom-hidden mt-2'>
                            <ChatBox
                                chatKey={`mobile-${chatIndex}`}
                                chatIndex={chatArray[chatIndex]}
                                sessions={sessions}
                                refreshAll={refreshAll}
                                setRefreshAll={setRefreshAll}
                                onDeleteSession={handleDelete}
                            />
                        </div>
                        ) 
                    }
                })} */}
            </div>
        </LayoutChat>
    );
};

export default Chat;

